// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"26":"720707ef1c8940b6","362":"8adf246ab0c4fa22","405":"720707ef1c8940b6","888":"64c9c09066c47a02"}[chunkId] + ".css";
};